import React from 'react'
import { Upload, Form, Icon, Input, Button, Row, Col, DatePicker } from 'antd';

export const ConsentFormStep3b = (props) => {
    if (props.currentStep !== 'Step 3b') {
      return null
    }
    return(
      <div className="form-group">


            <h3 style={{ display: 'inline-block !important' }}>Paper Consent Process</h3>

            <h4 style={{ display: 'inline-block !important' }}>Site ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.siteID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>User ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.userID}</span></h4>
            <h4 style={{  display: 'inline-block !important' }}>Subject ID: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.subjectID}</span></h4>
            <h4 style={{ display: 'inline-block !important' }}>Consent Type: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentPersonType}</span></h4>
            <h4 style={{ display: 'inline-block !important' }}>Consent Method: <span style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.consentMethodType}</span></h4>

            <Form.Item>
                {props.getFieldDecorator('consentFile', {
                    initialValue: props.dataset && props.dataset.filename ? props.dataset.filename : [],
                    valuePropName: 'fileList',
                    getValueFromEvent: props.normFile,
                    rules: [{
                        required: true,
                        message: 'Please upload the consent file!'
                    }],

                })(

                    <Upload
                        id="consentFile"
                        name="consentFile"
                        customRequest={props.fileDummyRequest}
                        accept=".pdf"
                        allowClear
                        size="large"
                        >
                        <Button>
                            <Icon type="upload" /> Upload Consent Form
                        </Button>
                    </Upload>

                )}
            </Form.Item>



            <Form.Item>
                {props.getFieldDecorator('consentProvided', {
                    initialValue: props.consentProvided,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Do you consent to the terms described above?'
                    }],
                })(
                  <label>
                    <h5>
                    Do you consent to the terms described above? If no, please click on the Back button!
                    </h5>
                      <select id="consentProvided" name="consentProvided" size="large" className="ant-input ant-input-lg">
                        <option value="">Provide Consent?</option>
                        <option value="yes">Yes</option>
                        <option value="">No</option>
                      </select>
                  </label>
                )}
            </Form.Item>


      </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeRedDeerCalgary/Step3b.js